import { DatabaseRecord, DatabaseRecordData, DatabaseType } from 'fitforce-offline-first';
import * as moment from 'moment';

interface AppErrorData extends DatabaseRecordData {
  name: string;
  message: string;
  metadata: any;
  timestamp: moment.Moment;
  status: number;
  statusText: string;
  url: string;
}

export class AppError extends DatabaseRecord {
  static recordName = 'AppError';
  static objectStoreName = 'errors';
  static fields = ['name', 'message', 'metadata', 'timestamp', 'status', 'statusText', 'url'];
  static databaseType = DatabaseType.User;

  name: string;
  message: string;
  metadata: any;
  timestamp: moment.Moment;
  status: number;
  statusText: string;
  url: string;

  constructor(data: AppErrorData) {
    super(data);
  }
}
